module.exports = __webpack_public_path__ + "img/b1-4-5.2fa1ea8a.jpg";